import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleDashed } from '@fortawesome/pro-solid-svg-icons/faCircleDashed';
import { faClipboardCheck } from '@fortawesome/pro-solid-svg-icons/faClipboardCheck';
import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Text, TextType } from 'ui-components/components/text';
import { AssistPanel } from '../assist-panel';
import { messages } from './messages';
import styles from './styles.module.less';

/**
 * ConfigureInventorySection component.
 * @param {object} props - The component props.
 * @param {boolean} props.isWarehouseConnected - Indicates if the warehouse is connected.
 * @param {boolean} props.isAnyProductInInventory - Indicates if there is any product in inventory.
 * @param {boolean} props.isInventoryTrackingEnabled - Indicates if inventory tracking is enabled.
 * @returns {JSX.Element} The rendered component.
 */
export const ConfigureInventoryPanel = ({ isWarehouseConnected, isAnyProductInInventory, isInventoryTrackingEnabled }) => {
  return (
    <AssistPanel
      header={
        <>
          <Text textType={TextType.H3} value={messages.panelHeader} />
          <Text textType={TextType.Paragraph} value={messages.panelInfo} />
        </>
      }
      icon={faClipboardCheck}
    >
      <div className={styles.step}>
        <div className={styles['step-header']}>
          <FontAwesomeIcon
            className={classNames({
              [styles['step-icon-done']]: isInventoryTrackingEnabled,
              [styles['step-icon-pending']]: !isInventoryTrackingEnabled,
            })}
            icon={isInventoryTrackingEnabled ? faCircleCheck : faCircleDashed}
          />
          <span className={styles['step-title']}>
            <FormattedMessage {...messages.setupConfigurationTitle} />
          </span>
        </div>
        <Text className={styles['step-info']} textType={TextType.Caption} value={messages.setupConfigurationInfo} />
      </div>
      <div className={styles.step}>
        <div className={styles['step-header']}>
          <FontAwesomeIcon
            className={classNames({
              [styles['step-icon-done']]: isWarehouseConnected,
              [styles['step-icon-pending']]: !isWarehouseConnected,
            })}
            icon={isWarehouseConnected ? faCircleCheck : faCircleDashed}
          />
          <span className={styles['step-title']}>
            <FormattedMessage {...messages.establishWarehouseTitle} />
          </span>
        </div>
        <Text className={styles['step-info']} textType={TextType.Caption} value={messages.establishWarehouseInfo} />
      </div>
      <div className={styles.step}>
        <div className={styles['step-header']}>
          <FontAwesomeIcon
            className={classNames({
              [styles['step-icon-done']]: isAnyProductInInventory,
              [styles['step-icon-pending']]: !isAnyProductInInventory,
            })}
            icon={isAnyProductInInventory ? faCircleCheck : faCircleDashed}
          />
          <span className={styles['step-title']}>
            <FormattedMessage {...messages.addInventoryCountTitle} />
          </span>
        </div>
        <Text className={styles['step-info']} textType={TextType.Caption} value={messages.addInventoryCountInfo} />
      </div>
    </AssistPanel>
  );
};
